/* eslint-disable max-classes-per-file */

import { IChatMessage, IFilterAction, IMachineMessage } from '../../interfaces/messenger';
import { IMachineStatusChange } from '../../interfaces/signal-r/machine-status-change';
import { IMachineTracking } from '../../interfaces/signal-r/machine-tracking';

export class ChatHasNonReadMessages {
  static readonly type = '[Chat] chat has non-read Message';
  constructor(public payload: number) {}
}

export class CloseAndOpenChatBox {
  static readonly type = '[Chat] close and open the chatActiveRoomComponentt';
  constructor(public payload: string) {}
}

export class GetMessagesAction {
  static readonly type = '[Chat] get messages through a request';
}

export class NewMessageReceivedAction {
  static readonly type = '[Chat] Receive the new message, sent by the server through SignalR';
  constructor(public payload: IChatMessage) {}
}

export class ChangeStatusReceivedAction {
  static readonly type = '[Chat] Receive a change of status, sent by the server through SignalR';
  constructor(public payload: IMachineStatusChange) {}
}

export class ChangeTrackingReceivedAction {
  static readonly type = '[Chat] Receive a change of tracking, sent by the server through SignalR';
  constructor(public payload: IMachineTracking) {}
}

export class SetActiveMessageAction {
  static readonly type = '[Chat] Selected message from chat list';
  constructor(public payload: IMachineMessage) {}
}

export class GetChatMessagesAction {
  static readonly type = '[Chat] get chat messages through a request';
  constructor(public payload: number) {}
}

export class SetChatLoadingAction {
  static readonly type = '[Chat] handle chat message loading';
  constructor(public payload: boolean) {}
}

export class BackAction {
  static readonly type = '[Chat] return to overview';
}

export class SelectedFilterAction {
  static readonly type = '[Chat] handles filter actions';
  constructor(public payload: IFilterAction) {}
}

export class SendMessageAction {
  static readonly type = '[Chat] send a message';
  constructor(public payload: string) {}
}

export class IsSendingMessageAction {
  static readonly type = '[Chat] handle the loading of the sended message ';
  constructor(public payload: boolean) {}
}

export class CheckMessagesAction {
  static readonly type = '[Chat] mark message as read';
}

export class NewMessageAddedAction {
  static readonly type = '[Chat] A new message has been added to the list';
  constructor(public payload: IChatMessage) {}
}

export class MessagesCheckedAction {
  static readonly type = '[Chat] Messages have been marked as read';
  constructor(public payload: boolean) {}
}

export class SendGlobalMessageAction {
  static readonly type = '[Chat] Send global message';
  constructor(public payload: string) {}
}

export class ResetStateAction {
  static readonly type = '[Chat] reset some state properties';
}

export class MessengerReconnectionAction {
  static readonly type = '[Chat] handle signal r reconnection';
}

export class IsGlobalMessageOpenAction {
  static readonly type = '[Chat] Reports whether the global messages section is open';
  constructor(public payload: boolean) {}
}
